import React from 'react'
import LoggedSidebar from 'App/Shell/LoggedSidebar'
import OrderItem from './OrderItem'
import '@loyal_template/order.css'
import { Select, Button } from 'loyal-react'
import PropTypes from 'prop-types'
const selectOptions = [
  {
    text: 'Últimos 7 dias',
    value: 1
  }
]
const Orders = props => (
  <div className='container-orders container-fluid px-0 px-md-1  bg-ui-4'>
    <div className='container pt-5 pb-2 py-md-4'>
      <div className='row pt-5 pt-md-0 mt-5 mt-md-0'>
        <LoggedSidebar selected={props.location.pathname} />
        <div className='user-content col-12 col-md-8 border-color-ui-3 bg-white border radius'>
          <div className='row px-3 py-2 border-bottom border-color-ui-3 '>
            <div className='col py-1 mr-auto'>
              <h3 className='txt-initial color-brand-1 mr-auto'>Pedidos</h3>
            </div>
            <div className={`col-12 col-md-3 d-none d-md-block `}>
              <div className='row'>
                <Select
                  id='ordernar'
                  label='Ordenar por'
                  className='col-12 px-0'
                  value={selectOptions[0]}
                  displayValue='text'
                  selectedValue='value'
                  options={selectOptions}
                />
              </div>
            </div>
          </div>

          <div className='container draggable py-3 border-bottom border-color-ui-3 '>
            <div className='row flex-nowrap flex-md-wrap'>
              <div className='col px-half'>
                <Button
                  id={'7_dias'}
                  name={'7_dias'}
                  text='7&nbsp;dias'
                  className='btn-sm border-color-ui-2 py-1 px-1 txt-body-sm txt-left'
                />
              </div>
              <div className='col px-half'>
                <Button
                  id={'15_dias'}
                  name={'15_dias'}
                  text='15&nbsp;dias'
                  className='btn-sm py-1 px-1 txt-body-sm txt-left'
                />
              </div>
              <div className='col px-half'>
                <Button
                  id={'1_mes'}
                  name={'1_mes'}
                  text='1&nbsp;mês'
                  className='btn-sm py-1 px-1 txt-body-sm txt-left'
                />
              </div>
              <div className='col px-half'>
                <Button
                  id={'3_meses'}
                  name={'3_meses'}
                  text='3&nbsp;meses'
                  className='btn-sm py-1 px-1 txt-body-sm txt-left'
                />
              </div>
              <div className='col px-half'>
                <Button
                  id={'6_meses'}
                  name={'6_meses'}
                  text='6&nbsp;meses'
                  className='btn-sm py-1 px-1 txt-body-sm txt-left'
                />
              </div>
              <div className='col px-half'>
                <Button
                  id={'1_ano'}
                  name={'1_ano'}
                  text='1&nbsp;ano'
                  className='btn-sm py-1 px-1 txt-body-sm txt-left'
                />
              </div>
            </div>
          </div>
          <OrderItem />
        </div>
      </div>
    </div>
  </div>
)
Orders.propTypes = {
  location: PropTypes.object
}
export default Orders



// WEBPACK FOOTER //
// ./src/features/User/Orders/Orders.js